export enum NoteOrigin {
  System = "System",
  User = "User"
}
